import React from 'react';

const Roles = () => {
  return (
    <div className="page">
      <h1>Roles & Permissions</h1>
      <p>Manage user roles and permissions here.</p>
      <div style={{ padding: '20px', background: 'white', borderRadius: '8px', marginTop: '20px' }}>
        <p>This feature is coming soon...</p>
      </div>
    </div>
  );
};

export default Roles;
